// Open Google Maps in a new tab from a direct user action to reduce popup blocking.
// We intentionally omit `origin`. Google Maps can infer the current location when available,
// otherwise the user may be prompted to set a start point.
export const openDirections = (destination: { latitude: number; longitude: number }): void => {
  const params = new URLSearchParams({
    api: '1',
    destination: `${destination.latitude},${destination.longitude}`,
    travelmode: 'driving',
  });

  window.open(`https://www.google.com/maps/dir/?${params.toString()}`, '_blank');
};
